import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/support`;

// return axs({
//   url: `${basePath}/list`,
//   params: {
//     languageGroup: payload?.languageGroup,
//     order: payload?.order,
//     page: payload?.page,
//     keyword: payload?.keyword,
//   },
//   method: 'get',
// });

// ?page=1
export function fetchFaqList(payload: object | any) {
  return axs({ url: `${basePath}/faq`, method: 'get', params: payload });
}
// support/faq/:fqaIdx
export function fetchFaqDetail(id: number) {
  return axs({ url: `${basePath}/faq/${id}`, method: 'get' });
}

// ?page=1
export function fetchQnaList(payload: object | any) {
  return axs({ url: `${basePath}/qna`, method: 'get', params: payload });
}
export function updateQna(payload: { title: string; content: string; status: number }) {
  return axs({ url: `${basePath}/qna`, method: 'post', data: payload });
}
export function completeUpdateQna(payload: { qnaIdx: number; isSuccess: number }) {
  return axs({ url: `${basePath}/qna/upload/complete`, method: 'put', data: payload });
}
// /support/qna/detail/:qnaIdx
export function fetchQnaDetail(id: number) {
  return axs({ url: `${basePath}/qna/${id}`, method: 'get' });
}

// export function fetchProjectHistories({ id, data }: { id: string; data: { page: number } }) {
//   return axs({ url: `${basePath}/history/${id}`, method: 'get', params: data });
// }
